import { mergeLeft } from 'ramda';
import { COLOR_SCHEME_DARK } from '@namespace/helpers';
import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';
import { ThemeConfig } from './types';

const initialState: ThemeConfig = {
  colorScheme: {
    selectedColorMode: COLOR_SCHEME_DARK,
    activeTheme: '',
    activeColorScheme: COLOR_SCHEME_DARK
  },
  iconsSet: {},
  imagesSet: {},
  componentsConfig: {},
  elementsConfig: {}
};

const init =
  (config: Partial<ThemeConfig>) =>
  (state: ThemeConfig): ThemeConfig =>
    Object.keys(config).reduce(
      (currentState, key) => ({
        ...currentState,
        [key]: mergeLeft(
          config[key as keyof ThemeConfig] ?? {},
          currentState[key as keyof ThemeConfig] || {}
        )
      }),
      state
    );

export const useThemesStore = createHookStore<ThemeConfig>(
  STORE_NAMES.THEMES,
  initialState,
  undefined,
  init
);
